/**
 * BL-0418 — Transfert « tout à droite » des dual-lists Colonnes / Trier par.
 * Concatène les items disponibles à la sélection existante (pas de remplacement / swap).
 */
export function u2000TransferAllToSelected<T>(selected: T[], availableToAdd: T[]): T[] {
  return selected.concat(availableToAdd);
}
